import React, { Children } from 'react';
import { motion } from 'framer-motion';
import Card from './Card';
interface MasonryGridProps {
  items: {
    id: number;
    title: string;
    description: string;
    shortDescription: string;
    image: string;
    category: string;
    client: string;
    year: number;
    videoUrl: string;
  }[];
}
const MasonryGrid: React.FC<MasonryGridProps> = ({
  items
}) => {
  // Split items into 3 columns for a masonry layout
  const getColumnItems = (columnIndex: number) => {
    return items.filter((_, index) => index % 3 === columnIndex);
  };
  const column1 = getColumnItems(0);
  const column2 = getColumnItems(1);
  const column3 = getColumnItems(2);

  // Container animation
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  // Item animation
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <motion.div variants={containerVariants} initial="hidden" animate="show" className="projects-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-129">
      <div className="projects-column space-y-6 md:space-y-8" data-id="element-130">
        {column1.map(item => <motion.div key={item.id} variants={itemVariants} data-id="element-131">
            <Card id={item.id} title={item.title} description={item.description} shortDescription={item.shortDescription} image={item.image} category={item.category} client={item.client} year={item.year} videoUrl={item.videoUrl} data-id="element-132" />
          </motion.div>)}
      </div>
      <div className="projects-column space-y-6 md:space-y-8 mt-6 md:mt-12" data-id="element-133">
        {column2.map(item => <motion.div key={item.id} variants={itemVariants} data-id="element-134">
            <Card id={item.id} title={item.title} description={item.description} shortDescription={item.shortDescription} image={item.image} category={item.category} client={item.client} year={item.year} videoUrl={item.videoUrl} data-id="element-135" />
          </motion.div>)}
      </div>
      <div className="projects-column space-y-6 md:space-y-8 mt-0 md:mt-20" data-id="element-136">
        {column3.map(item => <motion.div key={item.id} variants={itemVariants} data-id="element-137">
            <Card id={item.id} title={item.title} description={item.description} shortDescription={item.shortDescription} image={item.image} category={item.category} client={item.client} year={item.year} videoUrl={item.videoUrl} data-id="element-138" />
          </motion.div>)}
      </div>
    </motion.div>;
};
export default MasonryGrid;